// needs hex value for color (seems the thing we use most) and returns either white or black depending on what contrasts more
export const getContrastColor = (color: string) => {
	if (!color || !color.match(/^#[0-9A-F]{6}$/i)) {
		return 'inherit';
	}

	if (isLightColor(color)) {
		return '#000000';
	} else {
		return '#ffffff';
	}
};

export const isLightColor = (color: string) => {
	const rgb = color
		.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
		.substring(1)
		.match(/.{2}/g)
		.map(x => parseInt(x, 16));
	return rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 150;
};
